import { Microfrontend } from '@cian/mf-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { CardSection } from 'shared/components/CardSection';
import { useMortgageMiniCalculatorMicrofrontend } from 'shared/hooks/useMortgageMiniCalculatorMicrofrontend';
import { offerSelector } from 'shared/selectors';
import { selectMortgageMiniCalculatorSecondaryEnabled } from 'shared/selectors/featureToggle';
import { selectIsMortgageBrokerBannerAvailable } from 'shared/selectors/mortgageBroker';
import { getIsFromBuilder, getIsFromSeller } from 'shared/selectors/newObject';
import { getDealType, isSale } from 'shared/utils/deal_type';
import { getOfferType, isUrban } from 'shared/utils/offer_type';

export const SecondaryMortgageCalculatorContainer: React.FC = () => {
  const isSecondaryMortgageCalculatorMFEnabled = useSelector(selectMortgageMiniCalculatorSecondaryEnabled);
  const isFromSeller = useSelector(getIsFromSeller);
  const isFromBuilder = useSelector(getIsFromBuilder);

  const FromBuilder = isFromBuilder || isFromSeller;

  const { isAvailable, manifest } = useMortgageMiniCalculatorMicrofrontend(isSecondaryMortgageCalculatorMFEnabled);

  const offer = useSelector(offerSelector);

  const isMortgageBrokerBannerEnabled = useSelector(selectIsMortgageBrokerBannerAvailable);

  const dealType = getDealType(offer);
  const offerType = getOfferType(offer);

  if (!isAvailable || !isSale(dealType) || !isUrban(offerType) || isMortgageBrokerBannerEnabled || FromBuilder) {
    return null;
  }

  return (
    <CardSection>
      <Microfrontend
        name={manifest.microfrontendName}
        image={manifest.imageVersion}
        runtime={manifest.runtimeName}
        instance={manifest.instanceId}
      />
    </CardSection>
  );
};

SecondaryMortgageCalculatorContainer.displayName = 'SecondaryMortgageCalculatorContainer';
